import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import "./SEC.css";

import photo1 from "../../images/projects/sec/img (1).jpg";
import photo2 from "../../images/projects/sec/img (2).jpg";
import photo3 from "../../images/projects/sec/img (3).jpg";
import photo4 from "../../images/projects/sec/img (4).jpg";
import photo5 from "../../images/projects/sec/img (5).jpg";
import photo6 from "../../images/projects/sec/img (6).jpg";
import photo7 from "../../images/projects/sec/img (7).jpg";
import photo8 from "../../images/projects/sec/img (8).jpg";
import photo9 from "../../images/projects/sec/img (9).jpg";
import photo10 from "../../images/projects/sec/img (10).jpg";
import photo11 from "../../images/projects/sec/img (11).jpg";
import photo12 from "../../images/projects/sec/img (12).jpg";
import photo13 from "../../images/projects/sec/img (13).jpg";
import photo14 from "../../images/projects/sec/img (14).jpg";
import photo15 from "../../images/projects/sec/img (15).jpg";
import photo16 from "../../images/projects/sec/img (16).jpg";

function SEC() {
  useEffect(() => {
    AOS.init({ 
      duration: 1200,
      once: true,
      easing: 'ease-out-cubic'
    });
  }, []);

  const photos = [
    {
      src: photo1,
      alt: "Sedaqat Educational Center classroom",
      title: "Sedaqat Educational Center",
      description: "Providing quality education to 140 students in Dasht-e-Barchi."
    },
    {
      src: photo2,
      alt: "Students learning at SEC",
      title: "Daily Learning Sessions",
      description: "Eight hours of comprehensive daily lessons in multiple subjects."
    },
    {
      src: photo3,
      alt: "SEC classroom environment",
      title: "Modern Learning Environment",
      description: "Well-equipped classrooms fostering academic excellence."
    },
    {
      src: photo4,
      alt: "Teachers and students",
      title: "Dedicated Educators",
      description: "Experienced teachers committed to student success."
    },
    {
      src: photo5,
      alt: "Student activities",
      title: "Interactive Learning",
      description: "Engaging educational activities for grades 1-6."
    },
    {
      src: photo6,
      alt: "Educational materials",
      title: "Learning Resources",
      description: "Books, stationery, and supplies for all students."
    },
    {
      src: photo7,
      alt: "SEC facility",
      title: "Safe Learning Space",
      description: "A secure and welcoming environment for children."
    },
    {
      src: photo8,
      alt: "Group learning",
      title: "Collaborative Education",
      description: "Students working together to achieve academic goals."
    },
    {
      src: photo9,
      alt: "Classroom instruction",
      title: "Quality Teaching",
      description: "Professional instruction in English, Math, and Pashto."
    },
    {
      src: photo10,
      alt: "Students studying",
      title: "Focused Learning",
      description: "Students developing essential skills for their future."
    },
    {
      src: photo11,
      alt: "Educational program",
      title: "Comprehensive Curriculum",
      description: "From basic principles to advanced subjects."
    },
    {
      src: photo12,
      alt: "SEC community",
      title: "Building Community",
      description: "Creating a supportive learning community for all."
    },
    {
      src: photo13,
      alt: "Student achievement",
      title: "Academic Success",
      description: "Celebrating student progress and achievements."
    },
    {
      src: photo14,
      alt: "Learning activities",
      title: "Engaging Programs",
      description: "Dynamic educational activities that inspire learning."
    },
    {
      src: photo15,
      alt: "SEC staff",
      title: "Dedicated Team",
      description: "Manager, assistant manager, teachers, and support staff."
    },
    {
      src: photo16,
      alt: "Educational excellence",
      title: "Excellence in Education",
      description: "Empowering the next generation through quality education."
    }
  ];

  return (
    <div>
      <h1 className="sec" data-aos="fade-down">
        <span className="sec-title-text">Sedaqat Educational Center</span>
      </h1>

      <div className="aboutsec" data-aos="fade-up">
        <h1 data-aos="fade-down" data-aos-delay="100">About Sedaqat Center</h1>
        <div className="donateSection">
          <p data-aos="fade-up" data-aos-delay="200">
            Managed by Ayesha Hakimi, Sedaqat Educational Center currently serves 140 students
            from first to sixth grade. Located in Dasht-e-Barchi, this center provides eight
            hours of daily lessons in subjects such as English, Math, Pashto, and basic principles
            (which include reading, writing, and arithmetic for grades one to three). The center
            employs four dedicated teachers, a manager, an assistant manager, and a guard. The monthly
            expenses range from $550 to $600, covering rent, utilities, staff salaries, and the distribution
            of stationery and books to all students. Our commitment is to provide quality education that
            empowers children to build a brighter future.
          </p>
        </div>
      </div>

      <hr />

      <div className="carousel-section" data-aos="fade-up">
        <h2 className="carousel-title" data-aos="fade-down" data-aos-delay="100">
          Our Photo Gallery
        </h2>
        <div data-aos="zoom-in" data-aos-delay="200">
          <Carousel 
            showArrows={true} 
            showThumbs={false} 
            infiniteLoop={true} 
            autoPlay={true} 
            interval={4000} 
            transitionTime={800} 
            showStatus={false}
          >
            {photos.map((photo, index) => (
              <div className="photo-section" key={index}>
                <h2 className="photo-title">{photo.title}</h2>
                <p className="photo-text">{photo.description}</p>
                <img src={photo.src} alt={photo.alt} className="photo" />
              </div>
            ))}
          </Carousel>
        </div>
      </div>

      <hr />
      
      <div className="whatWeDo" data-aos="fade-up">
        <h1 data-aos="fade-down" data-aos-delay="100">Our Educational Programs</h1>
        <p data-aos="fade-up" data-aos-delay="200">
          <strong>Our Mission:</strong> Excellence in Education<br/><br/>
          At Sedaqat Educational Center, we are committed to providing comprehensive education that prepares students for success. Our programs include:<br/><br/>
          <strong>• Academic Excellence:</strong> Offering daily lessons in English, Mathematics, Pashto, and fundamental literacy skills.<br/><br/>
          <strong>• Experienced Faculty:</strong> Four dedicated teachers working alongside professional management to ensure quality education.<br/><br/>
          <strong>• Complete Support:</strong> Providing all necessary educational materials, books, and stationery to every student at no cost.<br/><br/>
          <strong>• Safe Environment:</strong> A secure facility with professional staff ensuring the safety and wellbeing of all students.<br/><br/>
          <strong>• Grades 1-6 Coverage:</strong> Comprehensive curriculum from basic principles to advanced subjects for primary school students.<br/><br/>
          Our efforts are focused on nurturing young minds and building the foundation for lifelong learning and success.
        </p>
      </div>
    </div>
  );
}

export default SEC;